/**
 * Created by Ning Jiang on 6/23/2020.
 */
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {FreespinRespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/FreespinRespinZeroBetController";

export class CreepyCarnivalTwoFSRespinZeroBetController extends FreespinRespinZeroBetController {

    protected getZeroBetNumberLeft(data:ParsedServerData):number {
        return data.freespinsLeft - 1;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === "RESPIN_FREESPIN";
    }
}